<template>
  <div class="common-container">
    <div class="list">
      <el-empty v-if="resultData.list.length < 1" description="暂无产品"></el-empty>
      <div class="main" v-else>
        <div class="pl-item" v-for="(v,i) in resultData.list" :key="i"
             @click="$router.push(`/product/detail?productId=${v.productId}&name=${v.classifyNames[0]}&classifyId=${v.classifyIds[0]}&source=list`)">
          <el-image :src="v.image"></el-image>
          <div class="name">{{ v.name }}</div>
        </div>
      </div>
      <el-pagination
          v-if="resultData.list.length > 0"
          @current-change="currentPageChange"
          :page-size="15"
          layout="total, prev, pager, next, jumper"
          :total="resultData.count">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductList",
  data() {
    return {
      resultData: {
        list: [],
        count: 0
      },
      page: 1,
      productName: ''
    }
  },
  watch: {
    '$route.query': {
      immediate: true,
      deep: true,
      handler({productName}) {
        this.productName = productName
        this.resultData = {
          list: [],
          count: 0
        }
        this.page = 1
        this.getDataList()
      }
    }
  },
  methods: {
    /**
     * 获取数据列表
     */
    getDataList() {
      this.$request.get('/Product/pageList', {
        params: {
          page: this.page,
          name: this.productName,
          type: 1
        }
      }).then(res => {
        if (res.code === 0) {
          this.resultData = res.data
        }
      })
    },
    /**
     * 翻页
     **/
    currentPageChange(current) {
      this.page = current
      this.getDataList()
    }
  }
}
</script>

<style scoped lang="scss">
.list {
  width: 1200px;
  padding: 30px 0 60px 0;

  .el-empty {
    margin-top: 30px;
  }

  .main {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 20px;

    .pl-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 220px;
      height: 262px;
      background-color: #FFFFFF;
      border-radius: 8px;
      overflow: hidden;
      cursor: pointer;
      transition: all .3s;

      &:hover {
        box-shadow: 0 1px 7px rgba(136, 147, 169, 0.24);
        transform: scale(1.03);
      }

      .el-image {
        width: 100%;
        height: 208px;
      }

      .name {
        text-align: center;
        width: 100%;
        padding: 0 10px;
        height: 54px;
        line-height: 54px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        color: #000000;
        font-weight: bold;
        font-size: 14px;
      }
    }
  }

  .el-pagination {
    text-align: center;
    margin-top: 30px;

    ::v-deep {
      button, .el-pager li, .el-input__inner {
        background-color: transparent !important;
      }
    }
  }
}
</style>